export const palette = {
    primary: {
        main: '#11203a',
        contrastText: '#fff'
    },
    secondary: {
        main: '#f8a21e',
        contrastText: '#fff'
    },
    tertiary: {
        main: '#26c1e8',
        contrastText: '#fff'
    },
    fourth: {
        main: '#1976d2',
        secondary: '#3b82f6',
        lightBg: '#3b82f630',
        lightBorder: '#3b82f630',
        hover: '#115293',
        contrastText: '#fff'
    },
    white: {
        main: '#f5f5f5',
        contrastText: '#11203a'
    },
    black: {
        lightBg: '#00000033'
    },
    gray: {
        main: '#808080'
    },
    error: {
        main: '#f44336',
        secondary: '#ef4444',
        lightBg: '#ef444426',
        lightBorder: '#ef444480'
    },
    warning: {
        main: '#ff9800'
    },
    info: {
        main: '#2196f3'
    },
    success: {
        main: '#06CD47',
        secondary: '#22c55e',
        lightBg: '#1a5160',
        lightBorder: '#22c55e80'
    }
};
